import { createFileRoute } from '@tanstack/react-router';
import { SEO } from '@/components/SEO';
import { TwoPhoneHeroDemo } from '@/components/poc/TwoPhoneHeroDemo';

function TwoPhoneRoute() {
  return (
    <>
      <SEO
        title='Two-phone sync POC'
        description='A calendar trade request visibly syncs between two parents phones.'
        path='/poc/two-phone'
        noindex
      />
      <TwoPhoneHeroDemo />
    </>
  );
}

export const Route = createFileRoute('/poc/two-phone')({
  component: TwoPhoneRoute,
});
